/**
 * Created by Alican Köker on 2018-07-10.
 */
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Power2, Power3, Timeline, TimelineLite, TweenLite} from "gsap";

export class FruitsInitialWinCountUp extends BitmapWinCountUp {

    constructor() {
        super({
            font : {
                name : "WinNumbersBM",
                size : 38
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public getCountUpAnimation(from:number, to:number, duration:number, winSize:number = 3):Timeline {

        let scaleTo = 0.5 + (winSize * 0.17);


        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUp.scale, 1.3,
                {x : 0.17, y : 0.17},
                {
                    x : scaleTo,
                    y : scaleTo,
                    ease : Elastic.easeOut.config(2, 1)
                }),
        ]);

        return timeline;
    }

    public onAbortCountUp(endValue:number):TimelineLite{
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUp.scale, 0.2,
                {x : 0.17, y : 0.17},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        return tl;

    }

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUp.scale, 0.2,
                {x : 0.17, y : 0.17},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        return timeline;
    }

    public getEndingAnimation():Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(this._countUp, 0.2, {alpha : 0}), "+= 0.5"); // stay a while after count up.
        return timeline;
    }
}